import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import manipal from "../../../assets/nw/Manipal_Hospitals_logo.png";
import kempegowda from "../../../assets/nw/KEMPEGOWDA-1.png";
import aadya from "../../../assets/nw/KEMPEGOWDA-1.png";
import atreya from "../../../assets/nw/KEMPEGOWDA-2.png";
import suraksha from "../../../assets/nw/KEMPEGOWDA-3.png";

const hospitalLogos = [
  { id: 1, image: manipal, name: "Manipal Hospital" },
  { id: 2, image: kempegowda, name: "Kempegowda Hospital" },
  { id: 3, image: aadya, name: "Aadya Hospital" },
  { id: 4, image: atreya, name: "Atreya Ayurveda College & Hospital" },
  { id: 5, image: suraksha, name: "Suraksha Hospital" },
];

const NeighbourhoodHospitals = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#000",
        py: 8,
        color: "#fff",
      }}
    >
      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          textAlign: "center",
          px: 2,
        }}
      >
        {/* Heading */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            letterSpacing: "1px",
            mb: 1,
          }}
        >
          NEIGHBOURHOOD HOSPITALS
        </Typography>

        {/* Subheading */}
        <Typography
          variant="body1"
          sx={{
            color: "#ccc",
            fontSize: "18px",
            mb: 5,
          }}
        >
          Leading Health Industries Near To Our Project Location
        </Typography>

        {/* Hospital Logos */}
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="center"
        >
          {hospitalLogos.map((hospital) => (
            <Grid
              item
              key={hospital.id}
              xs={6}
              sm={4}
              md={2.4}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={hospital.image}
                alt={hospital.name}
                sx={{
                  width: "140px",
                  height: "auto",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  p: 2,
                  boxShadow: "0 4px 15px rgba(255,255,255,0.1)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 6px 25px rgba(255,255,255,0.3)",
                  },
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default NeighbourhoodHospitals;
